exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logistics-mode-treeselect[data-v-804c434a] .vue-treeselect .vue-treeselect__value-container{white-space:nowrap;overflow:hidden}", ""]);

// exports
